import { useEffect } from "react";

import { AnyEntityId, EntityType } from "@mapmycustomers/shared/types/entity";

import { UiSyncListener } from "@app/store/uiSync/actions";

const useDataRefreshing = (
  entityTypes: EntityType[],
  reloadData: () => void,
  subscribe: (payload: { entityTypes: EntityType[]; listener: UiSyncListener }) => void,
  unsubscribe: (payload: { entityTypes: EntityType[]; listener: UiSyncListener }) => void,
  entityId?: AnyEntityId
) => {
  useEffect(
    () => {
      const listener: UiSyncListener = {
        onAdd: (entityType, entities) => {
          if (!entityId || entities.some(({ id }) => id === entityId)) {
            reloadData();
          }
        },
        onDelete: (entityType, entitiesIds) => {
          if (!entityId || entitiesIds.includes(entityId)) {
            reloadData();
          }
        },
        onUpdate: (entityType, entities) => {
          if (!entityId || entities.some(({ id }) => id === entityId)) {
            reloadData();
          }
        },
      };
      subscribe({ entityTypes, listener });
      return () => {
        unsubscribe({ entityTypes, listener });
      };
    },
    // we use spread operator with entityTypes for a reason:
    // to allow using array as a first argument of this hook without
    // being afraid to get re-rendering
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [reloadData, subscribe, unsubscribe, ...entityTypes]
  );
};

export default useDataRefreshing;
